"use professional"
import { useState, useEffect } from "react"
import ProjectCard from "./ProjectCard"
import Pagination from "../pagination"
import {Link} from "react-router-dom"

function ProjectList({ toggleSidebar, isSidebarOpen, toggleFiltersModal, userId }) {
  const [projects, setProjects] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [searchTerm, setSearchTerm] = useState("") // Added state for search term
  const [professionalSkills, setProfessionalSkills] = useState([]) // Added state for professional skills
  const [professionalProjectTypes, setProfessionalProjectTypes] = useState([]); // Added state for professional project types
  const [educationData, setEducationData] = useState([]); // Added state for education data
  const [experienceData, setExperienceData] = useState([]); // Added state for experience data
  const [sortOption, setSortOption] = useState(""); // Added state for sorting
  const itemsPerPage = 6

  useEffect(() => {
    // Call activate-profile endpoint on mount or when userId changes
    if (userId) {
      fetch(`http://localhost:5000/activate-profile/${userId}`, { method: "POST" })
        .then(res => res.json())
        .then(data => {
          // Optionally handle response, e.g., show a toast or log
          // console.log(data);
        })
        .catch(() => {});
    }
    fetchProjects()
    fetchProfessionalSkills() // Fetch professional skills when component mounts
    fetchProfessionalProjectTypes(); // Fetch professional project types when component mounts
    fetchEducationData(); // Fetch education data when component mounts
    fetchExperienceData(); // Fetch experience data when component mounts
  }, [currentPage, userId]) // Added userId as a dependency

  const fetchProfessionalProjectTypes = async () => {
    try {
      const response = await fetch(`http://localhost:5000/professional-projects/${userId}`);
      const data = await response.json();
      const projectTypes= data.map(types => types.type);
      console.log('project types:', projectTypes);
      setProfessionalProjectTypes(projectTypes);
    } catch (error) {
      console.error('Error fetching project details:', error);
    }
  };

  const fetchProfessionalSkills = async () => {
    try {
      const response = await fetch(`http://localhost:5000/professional-skills?userId=${userId}`)
      const data = await response.json()
      const skills = data.map(skill => skill.skill_name)
      console.log('professional skills:', skills)
      setProfessionalSkills(skills)
    } catch (error) {
      console.error('Error fetching professional skills:', error)
    }
  }

  const fetchEducationData = async () => {
    try {
      const response = await fetch(`http://localhost:5000/profile/${userId}`);
      const data = await response.json();
      console.log('education data:', data.education);
      setEducationData(data.education || []);
    } catch (error) {
      console.error('Error fetching education data:', error);
    }
  };

  const fetchExperienceData = async () => {
    try {
      const response = await fetch(`http://localhost:5000/profile/${userId}`);
      const data = await response.json();
      console.log('experience data:', data.experience);
      setExperienceData(data.experience || []);
    } catch (error) {
      console.error('Error fetching experience data:', error);
    }
  };

  const fetchProjects = async () => {
    try {
      const response = await fetch(`http://localhost:5000/clients--projects?status=unassigned&page=${currentPage}&limit=${itemsPerPage}`)
      const data = await response.json()
      console.log('projects:', data)
      setProjects(data)
    } catch (error) {
      console.error('Error fetching projects:', error)
    }
  }

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber)
  }

  const calculateMatchPercentage = (projectSkills, professionalSkills, projectType, professionalProjectTypes) => {
    if (!projectSkills || !professionalSkills) return 0;
  
    const projectSkillsArray = projectSkills.split(',').map(skill => skill.trim().toLowerCase());
    const professionalSkillsArray = professionalSkills.map(skill => skill.toLowerCase());
    const matchingSkills = projectSkillsArray.filter(skill => professionalSkillsArray.includes(skill));
    let matchPercentage = (matchingSkills.length / projectSkillsArray.length) * 100;
  
    // Check if the professional has the same project type
    if (professionalProjectTypes.includes(projectType)) {
      matchPercentage += 10; // Add extra percentage if the professional has the same project type
    } else {
      matchPercentage -= 10; // Subtract percentage if the professional does not have the same project type
    }

    if (matchPercentage > 100) {
      matchPercentage = 100; // Cap the percentage at 100%
    }
  
    return matchPercentage;
  };

  const handleSort = (projects) => {
    if (sortOption === "Budget: High to Low") {
      return [...projects].sort((a, b) => parseFloat(b.budget_range) - parseFloat(a.budget_range));
    } else if (sortOption === "Budget: Low to High") {
      return [...projects].sort((a, b) => parseFloat(a.budget_range) - parseFloat(b.budget_range));
    } else if (sortOption === "Newest") {
      return [...projects].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at)); // Sort by latest updated_at
    } else if (sortOption === "Match Percentage") {
      return [...projects].sort((a, b) => 
        calculateMatchPercentage(b.skills, professionalSkills, b.type, professionalProjectTypes) -
        calculateMatchPercentage(a.skills, professionalSkills, a.type, professionalProjectTypes)
      );
    }
    return projects;
  };

  const filteredProjects = projects.filter(
    (project) =>
      project.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      project.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (project.skills &&
        project.skills
          .split(',')
          .map(skill => skill.trim().toLowerCase()) // Trim and normalize skills
          .join(', ')
          .includes(searchTerm.toLowerCase()))
  )

  const sortedProjects = handleSort(filteredProjects); // Apply sorting to filtered projects

  return (
    <main className={`flex-grow transition-margin duration-300 ease-in-out ${isSidebarOpen ? "ml-96" : ""}`}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '32px 16px' }}>
        {/* Search & Sort Bar */}
        <div style={{
          background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '16px',
          padding: '20px 24px', marginBottom: '28px',
        }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '12px', alignItems: 'center', justifyContent: 'space-between' }}>
            <form style={{ display: 'flex', flex: 1, minWidth: '260px' }} onSubmit={e => e.preventDefault()}>
              <input
                type="text"
                placeholder="Search projects..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                  flex: 1, padding: '12px 18px', background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)',
                  borderRadius: '12px 0 0 12px', color: 'var(--text-primary)', fontSize: '0.9rem', outline: 'none',
                }}
              />
              <button type="submit" style={{
                padding: '12px 20px', background: 'linear-gradient(135deg, #10b981, #059669)', border: 'none',
                borderRadius: '0 12px 12px 0', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.9rem',
              }}>Search</button>
            </form>
            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              style={{
                padding: '12px 16px', background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)',
                borderRadius: '12px', color: 'var(--accent-cyan)', fontSize: '0.85rem', cursor: 'pointer', outline: 'none',
              }}
            >
              <option value="">Sort by</option>
              <option value="Relevance">Relevance</option>
              <option value="Budget: High to Low">Budget: High to Low</option>
              <option value="Budget: Low to High">Budget: Low to High</option>
              <option value="Newest">Newest</option>
              <option value="Match Percentage">Match Percentage</option>
            </select>
          </div>
        </div>

        <section style={{ marginBottom: '40px' }}>
          {/* Warning banners */}
          {[
            { cond: professionalSkills.length === 0, text: 'There are no skills available.', link: '/AddSkill', btn: 'Add Skill', color: '#60a5fa' },
            { cond: educationData.length === 0, text: 'There is no education data available.', link: '/AddEducation', btn: 'Add Education', color: '#fbbf24' },
            { cond: experienceData.length === 0, text: 'There is no experience data available.', link: '/AddWorkExperience', btn: 'Add Work Experience', color: '#a78bfa' },
            { cond: professionalProjectTypes.length === 0, text: 'There are no projects available.', link: '/AddProject', btn: 'Add Project', color: '#34d399' },
          ].filter(w => w.cond).map((w, i) => (
            <div key={i} style={{
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginBottom: '16px',
              padding: '14px 20px', borderRadius: '12px', background: 'rgba(248,113,113,0.06)', border: '1px solid rgba(248,113,113,0.15)',
            }}>
              <span style={{ color: '#f87171', fontSize: '0.9rem' }}>{w.text}</span>
              <Link to={w.link} style={{
                padding: '6px 16px', borderRadius: '8px', background: w.color, color: '#fff',
                textDecoration: 'none', fontWeight: 600, fontSize: '0.8rem', transition: 'opacity 0.2s',
              }}>{w.btn}</Link>
            </div>
          ))}

          {professionalSkills.length > 0 && educationData.length > 0 && experienceData.length > 0 && projects.length > 0 && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {sortedProjects.filter(project => filteredProjects.includes(project)).map((project, index) => (
                <ProjectCard
                  key={index}
                  project={project}
                  matchPercentage={calculateMatchPercentage(project.skills, professionalSkills, project.type, professionalProjectTypes)}
                />
              ))}
            </div>
          )}
        </section>

        {professionalSkills.length > 0 && educationData.length > 0 && experienceData.length > 0 && projects.length > 0 && (
          <Pagination
            itemsPerPage={itemsPerPage}
            totalItems={projects.length}
            paginate={paginate}
            currentPage={currentPage}
          />
        )}
      </div>
    </main>
  )
}

export default ProjectList